
import { Component, Vue, Prop } from "vue-property-decorator";
@Component
export default class TigerSchoolFootBanner extends Vue {
  @Prop() public footbannerOption!: any;
}
